import React from 'react';

export default () => <div>There was an error displaying the snippet.</div>;
